import { Actions, Subjects } from '@efexteam/permission-manager';

/* eslint-disable import/prefer-default-export */
export const USER_ACTIONS = [
  {
    label: 'editMmbPayments',
    actions: [Actions.CREATE, Subjects.PAYMENTS],
  },
  {
    label: 'editMmbAddFunds',
    actions: [Actions.READ, Subjects.ADD_FUNDS],
  },
  {
    label: 'editMmbAddGlobalAccounts',
    actions: [Actions.CREATE, Subjects.GLOBAL_ACCOUNTS],
  },
  {
    label: 'editMmbWithdrawals',
    actions: [Actions.CREATE, Subjects.WITHDRAW_FUNDS],
  },
  {
    label: 'editMmbDownloadStatements',
    actions: [Actions.READ, Subjects.ACCOUNT_STATEMENTS],
  },
  {
    label: 'editMmbAddBeneficiaries',
    actions: [Actions.CREATE, Subjects.BENEFICIARIES],
  },
  {
    label: 'editMmbDeleteAccount',
    actions: [Actions.DELETE, Subjects.TEAM_MEMBERS],
  },
  {
    label: 'editMmbTeamMembers',
    actions: [Actions.CREATE, Subjects.TEAM_MEMBERS],
  },
  {
    label: 'editMmbTeamMemberRole',
    actions: [Actions.UPDATE, Subjects.TEAM_MEMBERS],
  },
  {
    label: 'editMmbTeamMemeberDelete',
    actions: [Actions.DELETE, Subjects.TEAM_MEMBERS],
  },
  {
    label: 'editMmbTransferToOtherMember',
    actions: [Actions.MANAGE, Subjects.PAYMENTS],
  },
  {
    label: 'editMmbApprovePayments',
    actions: [Actions.CREATE, Subjects.PAYMENTS],
  },
];
